var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildTitle, buildStandardMeta, buildOgMeta, buildLink, buildStructureData, buildOgMetaRefs, } from '../../types/builders';
/**
 Here you can find more details about the implementation
 https://docs.google.com/document/d/1n-QE6LXncd_wqz9eQKufxMWnalE-WYxEzdrZ7rixF2A/edit#heading=h.8n2lir49tnp7
*/
export var EVENTS_PAGE = {
    tags: __spreadArrays([
        buildTitle('{{event.name}} | {{site.name}}'),
        buildStandardMeta('description', '{{event.seo.description}}'),
        buildStandardMeta('robots', 'index')
    ], buildOgMetaRefs(), [
        buildOgMeta('og:image', "{{event.main.image.url}}"),
        buildOgMeta('og:image:width', "{{event.image.width}}"),
        buildOgMeta('og:image:height', "{{event.image.height}}"),
        buildOgMeta('og:site_name', '{{site.name}}'),
        buildOgMeta('og:type', 'website'),
        buildOgMeta('og:url', "{{event.url}}"),
        buildLink('canonical', "{{event.url}}"),
        buildStructureData("{{event.structured-data.render}}", [
            '{{event.structured-data.disable-schema}}',
            '{{options.disable-pattern-schema}}',
        ]),
    ]),
};
